import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_ORDER_ITEM_RESET = 'POST_ORDER_ITEM_RESET';
export const POST_ORDER_ITEM_LOADING = 'POST_ORDER_ITEM_LOADING';
export const POST_ORDER_ITEM_SUCCESS = 'POST_ORDER_ITEM_SUCCESS';
export const POST_ORDER_ITEM_REJECT = 'POST_ORDER_ITEM_REJECT';

//* ACTIONS ------------------------------------------------
export const postOrderItemReset = () => ({ type: POST_ORDER_ITEM_RESET });
export const postOrderItemLoading = () => ({ type: POST_ORDER_ITEM_LOADING });
export const postOrderItemSuccess = (payload) => ({ type: POST_ORDER_ITEM_SUCCESS, payload });
export const postOrderItemReject = (payload) => ({ type: POST_ORDER_ITEM_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postOrderItemRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/api/Items/CreateOrderItem`, options);
};